import type { ErrorProperties, ErrorReporterFactory } from '../ErrorReporter';

const consoleErrorReporter: ErrorReporterFactory = (_config: any) => ({
  reportError: (error: Error, properties: ErrorProperties) =>
    console && console.error(error, properties),
});

export default consoleErrorReporter;
